export default "__VITE_ASSET__Dxqznek7__"